import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Instagram, Twitter, Youtube, Music2, Heart } from "lucide-react";
import TipDialog from "@/components/TipDialog";

export default function Footer() {
  const [tipOpen, setTipOpen] = useState(false);
  return (
    <footer className="bg-halo-navy text-halo-cream mt-20" data-testid="site-footer">
      <div className="px-6 md:px-12 lg:px-16 py-16 grid grid-cols-1 md:grid-cols-5 gap-10">
        <div className="md:col-span-2">
          <img
            src="https://customer-assets.emergentagent.com/job_halo-infield/artifacts/elck0w48_481151224_546514117820888_298116822983296389_n.jpg"
            alt="HITI Network"
            className="w-24 h-24 mb-4"
          />
          <div className="font-sports text-4xl uppercase tracking-tight leading-none">
            Halos <span className="text-halo-red">in the</span> Infield
          </div>
          <p className="mt-4 text-sm text-halo-cream/70 max-w-md font-body">
            A fan-run Angels baseball podcast network. Postgame reactions, deep-dive analysis,
            and the loudest seats in the section.
          </p>
        </div>
        <div>
          <div className="font-sports uppercase tracking-widest text-xs text-halo-red mb-4">Browse</div>
          <ul className="space-y-2 text-sm">
            <li><Link data-testid="footer-home" to="/" className="hover:text-halo-red">Home</Link></li>
            <li><Link data-testid="footer-podcasts" to="/podcasts" className="hover:text-halo-red">Podcasts</Link></li>
            <li><Link data-testid="footer-shop" to="/shop" className="hover:text-halo-red">Shop</Link></li>
          </ul>
        </div>
        <div>
          <div className="font-sports uppercase tracking-widest text-xs text-halo-red mb-4">Follow</div>
          <div className="flex flex-wrap gap-4">
            <a data-testid="footer-yt" href="https://www.youtube.com/@halosintheinfield" target="_blank" rel="noreferrer" aria-label="YouTube" className="hover:text-halo-red"><Youtube strokeWidth={2.5} /></a>
            <a data-testid="footer-ig" href="https://www.instagram.com/halos_in_the_infield/" target="_blank" rel="noreferrer" aria-label="Instagram" className="hover:text-halo-red"><Instagram strokeWidth={2.5} /></a>
            <a data-testid="footer-tw" href="https://x.com/HalosInfield" target="_blank" rel="noreferrer" aria-label="Twitter / X" className="hover:text-halo-red"><Twitter strokeWidth={2.5} /></a>
            <a data-testid="footer-tt" href="https://www.tiktok.com/@halos_in_the_infield" target="_blank" rel="noreferrer" aria-label="TikTok" className="hover:text-halo-red"><Music2 strokeWidth={2.5} /></a>
            <a data-testid="footer-ss" href="https://substack.com/@angelsbaseballhiti" target="_blank" rel="noreferrer" aria-label="Substack" className="hover:text-halo-red font-sports uppercase tracking-widest text-xs flex items-center">Substack</a>
          </div>
        </div>
        <div>
          <div className="font-sports uppercase tracking-widest text-xs text-halo-red mb-4">Support Us</div>
          <button
            onClick={() => setTipOpen(true)}
            data-testid="footer-tip-btn"
            className="inline-flex items-center gap-2 bg-halo-red hover:bg-halo-redHover text-white font-sports uppercase tracking-wider px-4 py-3 text-xs"
          >
            <Heart className="w-4 h-4 fill-white" strokeWidth={2.5} /> Tip the Podcast
          </button>
          <p className="text-[11px] font-body text-halo-cream/60 mt-3 max-w-[220px]">
            Every dollar keeps the postgame show on the air. Pay via PayPal.
          </p>
        </div>
      </div>
      <div className="border-t border-halo-navyLight px-6 md:px-12 lg:px-16 py-5 text-xs text-halo-cream/50 flex justify-between flex-wrap gap-2">
        <span>© {new Date().getFullYear()} Halos in the Infield. Not affiliated with the Los Angeles Angels.</span>
        <span className="font-sports uppercase tracking-widest">Trust the Process · Rally Cap Ready</span>
      </div>
      <TipDialog open={tipOpen} onOpenChange={setTipOpen} />
    </footer>
  );
}
